import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Mail } from 'lucide-react';

const GoverningBodyPage = () => {
  const officeBearers = [
    {
      designation: 'अध्यक्ष / President',
      name: 'Jethanand Meghrajji Kiri',
      location: 'Jodhpur',
      mobile: '7791077900',
    },
    {
      designation: 'उपाध्यक्ष / Vice President',
      name: 'Tolaram Ganeshmalji Chhunchha',
      location: 'Barmer',
      mobile: '9414106597',
    },
    {
      designation: 'मंत्री / Secretary',
      name: 'Pushpkumar Jhumarlalji Bhoot',
      location: 'Jodhpur',
      mobile: '9414134392',
    },
    {
      designation: 'उप-मंत्री / Deputy Secretary',
      name: 'Jagdish Chunnilalji Kiri',
      location: 'Bangalore',
      mobile: '9342815318',
    },
    {
      designation: 'कोषाध्यक्ष / Treasurer',
      name: 'Gautam Ratanlalji Kiri',
      location: 'Balotra',
      mobile: '9413308666',
    },
  ];

  const executiveMembers = [
    { srNo: 1, location: 'Jodhpur', name: 'Mohanlal Sukdevji Bhoot', mobile: '9829024057' },
    { srNo: 2, location: 'Jodhpur', name: 'Balkrishan Purshottam ji Chhunchha', mobile: '9414072252' },
    { srNo: 3, location: 'Barmer', name: 'Nandkishor Ishwardasji Chhunchha', mobile: '7297032093' },
    { srNo: 4, location: 'Barmer', name: 'Poonamchand Devilalji Chhunchha', mobile: '9414561204' },
    { srNo: 5, location: 'Balotra', name: 'Sewa Ram Lekhrajji Bhoot', mobile: '9414107754' },
    { srNo: 6, location: 'Balotra', name: 'Kishorkumar Jethmalji Chhunchha', mobile: '8460027847' },
    { srNo: 7, location: 'Sanchor', name: 'Ravatram Sitaramji Kiri', mobile: '9414532211' },
    { srNo: 8, location: 'Sanchor', name: 'Bhupatlal Lachhiramji Bhoot', mobile: '9929734779' },
    { srNo: 9, location: 'Pokaran/Ramdevra', name: 'Poonamprakash Valchandji Mandhu', mobile: '9414411803' },
    { srNo: 10, location: 'Pali Marwar', name: 'Bhagwandas Kistoorchandji Bichhda', mobile: '9414122963' },
    { srNo: 11, location: 'Udaipur', name: 'Chhagan Lal Hem Rajji Bhoot', mobile: '9252123909' },
    { srNo: 12, location: 'Jaipur', name: 'Omprakash Amolakchandji Mehra', mobile: '9001190801' },
    { srNo: 13, location: 'Bikaner', name: 'Poonamchand Bhikamchandji Chhunchha', mobile: '8560085820' },
    { srNo: 14, location: 'Bikaner', name: 'Ravishankar Ramratanji Chhunchha', mobile: '9214974529' },
    { srNo: 15, location: 'Jaisalmer', name: 'Satyanarayan Tikamchandji Dhada', mobile: '9460605982' },
    { srNo: 16, location: 'Phalodi', name: 'Sureshkumar Pratapchandji Chhunchha', mobile: '9413132560' },
    { srNo: 17, location: 'Daheli (Gujarat)', name: 'Shaileshkumar Manharlalji Kaku', mobile: '9979726511' },
    { srNo: 18, location: 'Deesa (Gujarat)', name: 'Kamlesh Kumar Purshottam Ji Kiri', mobile: '9426586379' },
    { srNo: 19, location: 'Surat (Gujarat)', name: 'Hukmi chand Laxminarayan ji Bhoot', mobile: '9825146250' },
    { srNo: 20, location: 'Ahmedabad (Gujarat)', name: 'Jaykumar Ganesh Malji Chhunchha', mobile: '9426072134' },
    { srNo: 21, location: 'Himmatnagar (Gujarat)', name: 'Maheshkumar Phoosaramji Bhoot', mobile: '9426701428' },
    { srNo: 22, location: 'Delhi', name: 'Advocate Sundarlal Ratanlalji Chhunchha', mobile: '9810187449' },
    { srNo: 23, location: 'Mumbai', name: 'Bhanwar Lal urf Azaad Bachhan Lalji Varde', mobile: '9867163063' },
    { srNo: 24, location: 'Bilaspur', name: 'Daulat vallabh Dasji Dhande', mobile: '9425220295' },
    { srNo: 25, location: 'Bangalore', name: 'Lekhraj Pukhrajji Chhunchha', mobile: '9844060542' },
    { srNo: 26, location: 'Hyderabad', name: 'Mahendra Mohanlalji Girachh', mobile: '9441424935' },
    { srNo: 27, location: 'Chennai', name: 'Ghevarchand Khimchandji Mandhu', mobile: '9840401512' },
    { srNo: 28, location: 'Hisar', name: 'Smt. Premlata Sureshji Bichhda', mobile: '9802022213' },
  ];

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="font-serif font-bold text-5xl md:text-7xl text-primary mb-4 tracking-tight">
            कार्यकारिणी समिति
          </h1>
          <h2 className="font-serif font-bold text-3xl md:text-4xl text-secondary mb-6">
            Governing Body
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Term: 29.09.2024 to 28.09.2027
          </p>
          <div className="mt-4 inline-flex items-center gap-2 text-sm text-muted-foreground bg-muted px-4 py-2 rounded-lg">
            <span className="font-semibold">Registration No:</span> S/ND/62/2023
          </div>
        </motion.div>

        {/* Office Bearers */}
        <section className="mb-16">
          <h3 className="font-serif font-bold text-3xl text-primary mb-8 text-center">
            पदाधिकारी / Office Bearers
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {officeBearers.map((bearer, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-card rounded-xl p-6 shadow-card border-2 border-secondary/20 hover:border-secondary/50 transition-colors"
              >
                <div className="mb-4">
                  <span className="inline-block bg-secondary/10 text-secondary px-3 py-1 rounded-full text-sm font-semibold">
                    {bearer.designation.split('/')[0].trim()}
                  </span>
                  <p className="text-xs text-muted-foreground mt-1">
                    {bearer.designation.split('/')[1]?.trim()}
                  </p>
                </div>
                <h4 className="font-serif font-bold text-xl text-foreground mb-3">
                  {bearer.name}
                </h4>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <MapPin size={16} className="text-secondary flex-shrink-0" />
                    <span>{bearer.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Phone size={16} className="text-secondary flex-shrink-0" />
                    <a href={`tel:+91${bearer.mobile}`} className="hover:text-secondary">
                      +91 {bearer.mobile}
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Executive Members */}
        <section>
          <h3 className="font-serif font-bold text-3xl text-primary mb-8 text-center">
            कार्यकारिणी सदस्य / Executive Committee Members
          </h3>
          <div className="bg-card rounded-xl shadow-card overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-primary text-primary-foreground">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold">
                      क्र.सं.<br />Sr. No.
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">
                      स्थान<br />Location
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">
                      सदस्य का नाम<br />Member Name
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">
                      मोबाईल नं.<br />Mobile No.
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {executiveMembers.map((member, index) => (
                    <tr
                      key={index}
                      className="hover:bg-muted/50 transition-colors"
                    >
                      <td className="px-4 py-3 text-sm font-medium text-secondary">
                        {member.srNo}
                      </td>
                      <td className="px-4 py-3 text-sm text-muted-foreground">
                        {member.location}
                      </td>
                      <td className="px-4 py-3 text-sm font-medium text-foreground">
                        {member.name}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <a
                          href={`tel:+91${member.mobile}`}
                          className="text-muted-foreground hover:text-secondary inline-flex items-center gap-2"
                        >
                          <Phone size={14} />
                          +91 {member.mobile}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="mt-16 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl p-8">
          <h3 className="font-serif font-bold text-2xl text-primary mb-6 text-center">
            संपर्क विवरण / Contact Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <MapPin className="text-secondary" size={20} />
              </div>
              <div>
                <p className="font-semibold text-foreground mb-1">मुख्यालय / Headquarters</p>
                <p className="text-sm text-muted-foreground">
                  15/287, Chopasani Housing Board,<br />
                  Jodhpur, Rajasthan - 342008
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Phone className="text-secondary" size={20} />
              </div>
              <div>
                <p className="font-semibold text-foreground mb-1">मोबाइल / Mobile</p>
                <a
                  href="tel:+919414134392"
                  className="text-sm text-muted-foreground hover:text-secondary"
                >
                  +91 9414134392
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3 md:col-span-2">
              <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Mail className="text-secondary" size={20} />
              </div>
              <div>
                <p className="font-semibold text-foreground mb-1">ईमेल / Email</p>
                <a
                  href="mailto:brahmkhatrimahasabha@gmail.com"
                  className="text-sm text-muted-foreground hover:text-secondary"
                >
                  brahmkhatrimahasabha@gmail.com
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Note */}
        <div className="mt-8 p-4 bg-muted rounded-lg">
          <p className="text-sm text-muted-foreground text-center">
            <strong>नोट / Note:</strong> आवश्यकतानुसार आगामी समय में कार्यकरिणी सदस्यों का संविधान की मंशानुसार और मनोनयन किया जायेगा। /
            As per requirements, additional executive committee members may be nominated in accordance with the constitution.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoverningBodyPage;
